import { BUTTON_TYPES } from '../../../../../../../../constants/button-variants';
import cn from '../../../../../../../../utils/classnames';
import MaterialPricesAndButtons from '../../../../components/material-prices-and-buttons/material-prices-and-buttons';
import { FavoritesMaterialCardVariationProps } from '../../../../favorites-material-card';
import './right-aside.scss';

const RightAside = (props: Omit<FavoritesMaterialCardVariationProps, 'shouldShowFolder'>) => {
    const isMaterialAcquired = Boolean(props.item.aclId);

    const asideClassNames = cn('right-aside', isMaterialAcquired ? 'acquired' : 'unacquired');

    return (
        <aside className={asideClassNames}>
            <MaterialPricesAndButtons
                {...props}
                shouldShowFolder={false}
                addToCartType='button'
                removeButtonType='removeOnly'
                downloadButtonType={BUTTON_TYPES.BUTTON}
            />
        </aside>
    );
};

export default RightAside;
